export const ADDED_MASHING_ITEMS = {
  MASHING_ID: 'mashingId',
  PERIOD_ID: 'periodId',
  MILLED_DATE: 'milledDate',
  MASH_DATE: 'mashDate',
  NOTE: 'note'
};

export const ADDED_MASHING_ITEMS_TO_MAP = Object.values(ADDED_MASHING_ITEMS);

export const UPDATED_MASHINGS_ID = 0;
